import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BannerComponent } from './banner.component';
import { SharedModule } from '../shared.module';
import { BorrowerPersonalLoanApplicationService }
  from '../services/borrower-personal-loan-application/borrower-personal-loan-application';
import { LoanStateDirectorService as PLLoanStateDirector } from '../../pages/personal-loans/shared/services/loan-state-director.service';

@NgModule({
  declarations: [
    BannerComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    BannerComponent
  ],
  providers: [
    PLLoanStateDirector,
    BorrowerPersonalLoanApplicationService
  ]
})
export class BannerModule {

}
